import { FormProvider, SubmitHandler, useForm } from "react-hook-form";

import { ActionButtons, ErrorModal, SuccessModal } from "@components";
import { UploadDocumentForm } from "./UploadDocumentForm";

import { OtherAttachedFilesFormDataType } from "@validations/HRM/employee/attachedFiles";
import { UserManualType } from "@type/HRM/settings/user-manual";
import { useEffect, useState } from "react";

interface NewUploadDocumentPropsType {
  handleNewUploadDocumentFormShow: (param: boolean) => void;
  modules: any;
  createUserManual: (id: number | string, reqData: UserManualType) => void;
}

const NewUploadDocument = ({
  handleNewUploadDocumentFormShow,
  createUserManual,
  modules,
}: NewUploadDocumentPropsType) => {
  const methods = useForm<any>();

  const { handleSubmit } = methods;
  const onSubmit: SubmitHandler<any> = (data: any) => {
    createUserManual("", data as UserManualType);
  };

  return (
    <>
      <FormProvider {...methods}>
        <form className="container" onSubmit={handleSubmit(onSubmit)}>
          <UploadDocumentForm modules={modules} />
          <ActionButtons
            disabled
            closeAction={() => handleNewUploadDocumentFormShow(false)}
          />
        </form>
      </FormProvider>
    </>
  );
};

export default NewUploadDocument;
